import React from 'react';

export const ColorPaletteIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.11577 4.25031C6.89879 3.71327 6.26752 3.46769 5.78792 3.79248C5.02637 4.3082 4.3807 4.951 3.86844 5.67957C3.53516 6.15357 3.7695 6.78927 4.30289 7.01568L5.58576 7.56022C6.04992 7.75725 6.57926 7.56727 6.91843 7.19413C7.02182 7.0804 7.13194 6.97196 7.2485 6.86948C7.62735 6.53643 7.82685 6.01031 7.63789 5.5426L7.11577 4.25031Z"
        fill="#662D91"
      />
      <path
        d="M11.4575 5.16845C11.2605 5.63257 10.7479 5.86362 10.2447 5.83088C10.0915 5.82091 9.93711 5.81941 9.78224 5.82666C9.27835 5.85025 8.76937 5.61038 8.58041 5.14267L8.05829 3.85038C7.84131 3.31334 8.12481 2.69817 8.69542 2.59864C9.60126 2.44065 10.512 2.45447 11.3864 2.62259C11.9555 2.73201 12.2285 3.35211 12.0021 3.88551L11.4575 5.16845Z"
        fill="#ED1C24"
      />
      <path
        d="M15.7497 7.11516C16.2867 6.89817 16.5323 6.26691 16.2075 5.78731C15.6918 5.02576 15.049 4.38009 14.3204 3.86783C13.8464 3.53455 13.2107 3.76889 12.9843 4.30227L12.4398 5.58515C12.2428 6.04931 12.4327 6.57865 12.8059 6.91782C12.9196 7.02121 13.028 7.13132 13.1305 7.24788C13.4636 7.62674 13.9897 7.82624 14.4574 7.63727L15.7497 7.11516Z"
        fill="#F7931E"
      />
      <path
        d="M14.8315 11.4586C14.3674 11.2616 14.1364 10.749 14.1691 10.2458C14.1791 10.0926 14.1806 9.93821 14.1733 9.78333C14.1498 9.27945 14.3896 8.77047 14.8573 8.5815L16.1496 8.05938C16.6867 7.8424 17.3018 8.12591 17.4014 8.69652C17.5594 9.60236 17.5455 10.5131 17.3774 11.3875C17.268 11.9566 16.6479 12.2296 16.1145 12.0032L14.8315 11.4586Z"
        fill="#FFF34A"
      />
      <path
        d="M12.8848 15.7497C13.1018 16.2867 13.7331 16.5323 14.2127 16.2075C14.9742 15.6918 15.6199 15.049 16.1322 14.3204C16.4655 13.8464 16.2311 13.2107 15.6977 12.9843L14.4149 12.4398C13.9507 12.2427 13.4213 12.4327 13.0822 12.8059C12.9788 12.9196 12.8687 13.028 12.7521 13.1305C12.3733 13.4636 12.1738 13.9897 12.3627 14.4574L12.8848 15.7497Z"
        fill="#8CC63F"
      />
      <path
        d="M8.54332 14.8315C8.74032 14.3674 9.25299 14.1364 9.75612 14.1691C9.90935 14.1791 10.0637 14.1806 10.2186 14.1733C10.7225 14.1498 11.2315 14.3896 11.4204 14.8573L11.9426 16.1496C12.1595 16.6867 11.876 17.3018 11.3054 17.4014C10.3996 17.5593 9.48884 17.5455 8.61444 17.3774C8.04539 17.268 7.77232 16.6479 7.99874 16.1145L8.54332 14.8315Z"
        fill="#009245"
      />
      <path
        d="M4.25043 12.8829C3.71339 13.0999 3.46781 13.7311 3.7926 14.2107C4.30832 14.9723 4.95112 15.618 5.67969 16.1302C6.15369 16.4635 6.78939 16.2292 7.0158 15.6958L7.56035 14.4129C7.75737 13.9487 7.56739 13.4194 7.19426 13.0802C7.08052 12.9768 6.97208 12.8667 6.86961 12.7502C6.53655 12.3713 6.01043 12.1718 5.54272 12.3608L4.25043 12.8829Z"
        fill="#29ABE2"
      />
      <path
        d="M5.16906 8.54332C5.63318 8.74033 5.86423 9.25299 5.83149 9.75613C5.82152 9.90936 5.82002 10.0637 5.82727 10.2186C5.85086 10.7225 5.61099 11.2315 5.14328 11.4205L3.85099 11.9426C3.31395 12.1595 2.69878 11.876 2.59925 11.3054C2.44126 10.3996 2.45508 9.48884 2.6232 8.61444C2.73261 8.04539 3.35271 7.77233 3.88612 7.99875L5.16906 8.54332Z"
        fill="#0071BC"
      />
    </svg>
  );
};
